import React, { useState, Fragment } from 'react';
import { CommandCenterLayout } from '../../components/layout/CommandCenterLayout';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { DataTable } from '../../components/ui/DataTable';
import { StatusBadge } from '../../components/ui/StatusBadge';
import { Modal } from '../../components/ui/Modal';
import { Select } from '../../components/ui/Select';
import { Textarea } from '../../components/ui/Textarea';
import { Plus, Search, Filter, Calendar, Users, Share2, MoreHorizontal, CheckCircle2, Clock, AlertCircle, Instagram, Facebook, Youtube, Twitter, Video, Image as ImageIcon, Link as LinkIcon, ChevronRight, ChevronLeft, Eye } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
// Mock Data
const mockCampaigns = [{
  id: 'CMP-001',
  title: 'Kampanye HPSN 2025: Pilah Sampah dari Rumah',
  status: 'active',
  startDate: '2025-02-10',
  deadline: '2025-02-21',
  platforms: ['instagram', 'tiktok', 'facebook'],
  receivers: 514,
  progress: 68,
  submitted: 350,
  validated: 320,
  contentCount: 3
}, {
  id: 'CMP-002',
  title: 'Sosialisasi Bank Sampah Unit',
  status: 'draft',
  startDate: '2025-03-01',
  deadline: '2025-03-15',
  platforms: ['instagram', 'whatsapp'],
  receivers: 120,
  progress: 0,
  submitted: 0,
  validated: 0,
  contentCount: 1
}, {
  id: 'CMP-003',
  title: 'Video Edukasi: Maggot BSF',
  status: 'completed',
  startDate: '2025-01-15',
  deadline: '2025-01-30',
  platforms: ['youtube', 'facebook'],
  receivers: 514,
  progress: 92,
  submitted: 475,
  validated: 470,
  contentCount: 1
}];
export function DistribusiKontenPage() {
  const navigate = useNavigate();
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [activeTab, setActiveTab] = useState('active'); // active, draft, completed
  const [step, setStep] = useState(1); // 1: Info, 2: Assets, 3: Target, 4: Review
  // Wizard State
  const [formData, setFormData] = useState({
    title: '',
    startDate: '',
    deadline: '',
    description: '',
    platforms: [] as string[],
    assets: [] as any[],
    receivers: 'all',
    utmTracking: true
  });
  const getPlatformIcon = (platform: string) => {
    switch (platform) {
      case 'instagram':
        return <Instagram className="h-4 w-4 text-pink-600" data-id="element-1139" />;
      case 'facebook':
        return <Facebook className="h-4 w-4 text-blue-600" data-id="element-1140" />;
      case 'youtube':
        return <Youtube className="h-4 w-4 text-red-600" data-id="element-1141" />;
      case 'twitter':
        return <Twitter className="h-4 w-4 text-sky-500" data-id="element-1142" />;
      case 'tiktok':
        return <span className="text-xs font-bold" data-id="element-1143">TT</span>;
      default:
        return <Share2 className="h-4 w-4" data-id="element-1144" />;
    }
  };
  const columns = [{
    header: 'Nama Campaign',
    cell: (row: any) => <div className="cursor-pointer hover:text-primary-600" onClick={() => navigate(`/command-center/distribusi/campaign/${row.id}`)} data-id="element-1145">
          <div className="font-medium text-gray-900" data-id="element-1146">{row.title}</div>
          <div className="text-xs text-gray-500 flex items-center gap-2 mt-1" data-id="element-1147">
            <span className="flex items-center gap-1" data-id="element-1148">
              <Calendar className="h-3 w-3" data-id="element-1149" /> {row.startDate} s/d{' '}
              {row.deadline}
            </span>
          </div>
        </div>
  }, {
    header: 'Target Platform',
    cell: (row: any) => <div className="flex gap-1" data-id="element-1150">
          {row.platforms.map((p: string) => <div key={p} className="p-1.5 bg-gray-100 rounded-full" title={p} data-id="element-1151">
              {getPlatformIcon(p)}
            </div>)}
        </div>
  }, {
    header: 'Penerima',
    cell: (row: any) => <div className="flex items-center gap-1 text-sm text-gray-600" data-id="element-1152">
          <Users className="h-4 w-4" data-id="element-1153" /> {row.receivers}
        </div>
  }, {
    header: 'Progress',
    cell: (row: any) => <div className="w-32" data-id="element-1154">
          <div className="flex justify-between text-xs mb-1" data-id="element-1155">
            <span className="font-medium" data-id="element-1156">{row.progress}%</span>
            <span className="text-gray-500" data-id="element-1157">
              {row.submitted}/{row.receivers}
            </span>
          </div>
          <div className="w-full bg-gray-100 rounded-full h-2" data-id="element-1158">
            <div className={`h-2 rounded-full ${row.progress >= 80 ? 'bg-green-500' : 'bg-blue-500'}`} style={{
          width: `${row.progress}%`
        }} data-id="element-1159"></div>
          </div>
        </div>
  }, {
    header: 'Status',
    cell: (row: any) => <StatusBadge status={row.status === 'active' ? 'hijau' : row.status === 'draft' ? 'abu' : 'biru'} data-id="element-1160">
          {row.status === 'active' ? 'Berjalan' : row.status === 'draft' ? 'Draft' : 'Selesai'}
        </StatusBadge>
  }, {
    header: 'Aksi',
    cell: (row: any) => <div className="flex gap-2" data-id="element-1161">
          <Button variant="ghost" size="sm" onClick={() => navigate(`/command-center/distribusi/campaign/${row.id}`)} data-id="element-1162">
            <Eye className="h-4 w-4" data-id="element-1163" />
          </Button>
          <Button variant="ghost" size="sm" data-id="element-1164">
            <MoreHorizontal className="h-4 w-4" data-id="element-1165" />
          </Button>
        </div>
  }];
  const filteredData = mockCampaigns.filter(c => (activeTab === 'all' || c.status === activeTab) && c.title.toLowerCase().includes(searchTerm.toLowerCase()));
  return <CommandCenterLayout title="Distribusi Konten" subtitle="Kelola kampanye distribusi konten ke seluruh jejaring daerah" data-id="element-1166">
      <div className="space-y-6" data-id="element-1167">
        {/* KPI Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1168">
          <Card data-id="element-1169">
            <CardContent className="p-6 flex items-center justify-between" data-id="element-1170">
              <div data-id="element-1171">
                <p className="text-sm font-medium text-gray-500" data-id="element-1172">
                  Campaign Aktif
                </p>
                <h3 className="text-2xl font-bold text-gray-900" data-id="element-1173">3</h3>
                <p className="text-xs text-green-600 flex items-center mt-1" data-id="element-1174">
                  <Clock className="h-3 w-3 mr-1" data-id="element-1175" /> Deadline terdekat: 2 hari
                </p>
              </div>
              <div className="p-3 bg-blue-50 text-blue-600 rounded-full" data-id="element-1176">
                <Share2 className="h-6 w-6" data-id="element-1177" />
              </div>
            </CardContent>
          </Card>
          <Card data-id="element-1178">
            <CardContent className="p-6 flex items-center justify-between" data-id="element-1179">
              <div data-id="element-1180">
                <p className="text-sm font-medium text-gray-500" data-id="element-1181">
                  Total Postingan
                </p>
                <h3 className="text-2xl font-bold text-gray-900" data-id="element-1182">1,240</h3>
                <p className="text-xs text-gray-500 mt-1" data-id="element-1183">
                  Dari 3 campaign bulan ini
                </p>
              </div>
              <div className="p-3 bg-green-50 text-green-600 rounded-full" data-id="element-1184">
                <CheckCircle2 className="h-6 w-6" data-id="element-1185" />
              </div>
            </CardContent>
          </Card>
          <Card data-id="element-1186">
            <CardContent className="p-6 flex items-center justify-between" data-id="element-1187">
              <div data-id="element-1188">
                <p className="text-sm font-medium text-gray-500" data-id="element-1189">
                  Compliance Rate
                </p>
                <h3 className="text-2xl font-bold text-gray-900" data-id="element-1190">78%</h3>
                <p className="text-xs text-red-600 flex items-center mt-1" data-id="element-1191">
                  <AlertCircle className="h-3 w-3 mr-1" data-id="element-1192" /> 22% belum posting
                </p>
              </div>
              <div className="p-3 bg-purple-50 text-purple-600 rounded-full" data-id="element-1193">
                <Users className="h-6 w-6" data-id="element-1194" />
              </div>
            </CardContent>
          </Card>
        </div>

        <Card data-id="element-1195">
          <CardHeader className="flex flex-row items-center justify-between pb-4" data-id="element-1196">
            <div data-id="element-1197">
              <CardTitle data-id="element-1198">Daftar Campaign</CardTitle>
              <CardDescription data-id="element-1199">
                Monitor status distribusi dan postingan daerah
              </CardDescription>
            </div>
            <Button onClick={() => setIsCreateModalOpen(true)} className="gap-2" data-id="element-1200">
              <Plus className="h-4 w-4" data-id="element-1201" /> Buat Campaign Baru
            </Button>
          </CardHeader>
          <CardContent data-id="element-1202">
            {/* Tabs */}
            <div className="flex border-b mb-6" data-id="element-1203">
              {['active', 'draft', 'completed'].map(tab => <button key={tab} className={`px-4 py-2 text-sm font-medium border-b-2 transition-colors ${activeTab === tab ? 'border-primary-600 text-primary-600' : 'border-transparent text-gray-500 hover:text-gray-700'}`} onClick={() => setActiveTab(tab)} data-id="element-1204">
                  {tab.charAt(0).toUpperCase() + tab.slice(1)}
                </button>)}
            </div>

            <div className="flex flex-col md:flex-row gap-4 mb-6" data-id="element-1205">
              <div className="relative flex-1" data-id="element-1206">
                <Search className="absolute left-3 top-2.5 h-4 w-4 text-gray-400" data-id="element-1207" />
                <Input placeholder="Cari campaign..." className="pl-9" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-1208" />
              </div>
              <div className="flex gap-2" data-id="element-1209">
                <Button variant="outline" className="gap-2" data-id="element-1210">
                  <Filter className="h-4 w-4" data-id="element-1211" /> Filter
                </Button>
              </div>
            </div>

            <DataTable data={filteredData} columns={columns} keyExtractor={item => item.id} data-id="element-1212" />
          </CardContent>
        </Card>
      </div>

      {/* Enhanced Create Campaign Modal */}
      <Modal isOpen={isCreateModalOpen} onClose={() => setIsCreateModalOpen(false)} title="Buat Campaign Distribusi" size="lg" footer={<div className="flex justify-between w-full" data-id="element-1214">
            <Button variant="ghost" onClick={() => step > 1 ? setStep(step - 1) : setIsCreateModalOpen(false)} data-id="element-1215">
              {step > 1 ? 'Kembali' : 'Batal'}
            </Button>
            <div className="flex gap-2" data-id="element-1216">
              {step === 4 && <Button variant="outline" onClick={() => setIsCreateModalOpen(false)} data-id="element-1217">
                  Simpan Draft
                </Button>}
              <Button onClick={() => step < 4 ? setStep(step + 1) : setIsCreateModalOpen(false)} data-id="element-1218">
                {step < 4 ? 'Lanjut' : 'Publish Campaign'}
              </Button>
            </div>
          </div>} data-id="element-1213">
        <div className="space-y-6" data-id="element-1219">
          {/* Stepper */}
          <div className="flex items-center justify-center mb-6" data-id="element-1220">
            {[{
            num: 1,
            label: 'Info'
          }, {
            num: 2,
            label: 'Assets'
          }, {
            num: 3,
            label: 'Target'
          }, {
            num: 4,
            label: 'Review'
          }].map((s, idx) => <Fragment key={s.num} data-id="element-1221">
                <div className={`flex items-center ${step >= s.num ? 'text-primary-600' : 'text-gray-400'}`} data-id="element-1222">
                  <div className={`w-8 h-8 rounded-full flex items-center justify-center border-2 ${step >= s.num ? 'border-primary-600 bg-primary-50' : 'border-gray-300'}`} data-id="element-1223">
                    {s.num}
                  </div>
                  <span className="ml-2 text-sm font-medium hidden sm:block" data-id="element-1224">
                    {s.label}
                  </span>
                </div>
                {idx < 3 && <div className={`w-8 sm:w-16 h-0.5 mx-2 ${step > s.num ? 'bg-primary-600' : 'bg-gray-300'}`} data-id="element-1225"></div>}
              </Fragment>)}
          </div>

          {step === 1 && <div className="space-y-4 animate-in fade-in" data-id="element-1226">
              <div data-id="element-1227">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1228">
                  Judul Campaign
                </label>
                <Input placeholder="Contoh: Kampanye HPSN 2025" data-id="element-1229" />
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-1230">
                <div data-id="element-1231">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1232">
                    Tanggal Mulai
                  </label>
                  <Input type="date" data-id="element-1233" />
                </div>
                <div data-id="element-1234">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1235">
                    Deadline Posting
                  </label>
                  <Input type="date" data-id="element-1236" />
                </div>
              </div>
              <div data-id="element-1237">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1238">
                  Instruksi Khusus
                </label>
                <Textarea placeholder="Instruksi untuk penerima (misal: Wajib tag akun @kementerianLHK)" data-id="element-1239" />
              </div>
              <div data-id="element-1240">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1241">
                  Platform Target (Wajib)
                </label>
                <div className="flex flex-wrap gap-3" data-id="element-1242">
                  {['Instagram', 'TikTok', 'Facebook', 'X', 'YouTube'].map(p => <label key={p} className="flex items-center gap-2 border p-2 rounded-lg cursor-pointer hover:bg-gray-50" data-id="element-1243">
                        <input type="checkbox" className="rounded text-primary-600" data-id="element-1244" />
                        <span className="text-sm" data-id="element-1245">{p}</span>
                      </label>)}
                </div>
              </div>
            </div>}

          {step === 2 && <div className="space-y-4 animate-in fade-in" data-id="element-1246">
              <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center hover:bg-gray-50 cursor-pointer transition-colors" data-id="element-1247">
                <Plus className="h-8 w-8 text-gray-400 mx-auto mb-2" data-id="element-1248" />
                <p className="text-sm font-medium text-gray-900" data-id="element-1249">
                  Pilih Konten dari Bank Konten
                </p>
                <p className="text-xs text-gray-500" data-id="element-1250">atau upload materi baru</p>
              </div>

              <div className="bg-gray-50 p-4 rounded-lg border flex gap-4 items-start" data-id="element-1251">
                <div className="h-16 w-16 bg-gray-200 rounded flex items-center justify-center flex-shrink-0" data-id="element-1252">
                  <Video className="h-8 w-8 text-gray-400" data-id="element-1253" />
                </div>
                <div className="flex-1" data-id="element-1254">
                  <div className="flex justify-between" data-id="element-1255">
                    <h4 className="font-medium text-gray-900" data-id="element-1256">
                      Video Teaser HPSN 2025.mp4
                    </h4>
                    <Button variant="ghost" size="sm" className="h-6 w-6 p-0 text-red-500" data-id="element-1257">
                      <MoreHorizontal className="h-4 w-4" data-id="element-1258" />
                    </Button>
                  </div>
                  <p className="text-xs text-gray-500 mb-2" data-id="element-1259">
                    15 MB • MP4 • Versi 1.0
                  </p>
                  <div data-id="element-1260">
                    <label className="block text-xs font-medium text-gray-700 mb-1" data-id="element-1261">
                      Caption Template
                    </label>
                    <Textarea className="text-xs h-16" defaultValue="Mari sukseskan HPSN 2025! Pilah sampah dari rumah untuk Indonesia bersih. #HPSN2025 #PilahSampah" data-id="element-1262" />
                  </div>
                </div>
              </div>
            </div>}

          {step === 3 && <div className="space-y-4 animate-in fade-in" data-id="element-1263">
              <div data-id="element-1264">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1265">
                  Target Penerima
                </label>
                <Select data-id="element-1266">
                  <option data-id="element-1267">Semua Dinas Lingkungan Hidup (Prov/Kab/Kota)</option>
                  <option data-id="element-1268">Hanya Provinsi</option>
                  <option data-id="element-1269">Hanya Kab/Kota</option>
                  <option data-id="element-1270">Komunitas Terdaftar</option>
                  <option data-id="element-1271">Custom...</option>
                </Select>
              </div>

              <div className="bg-blue-50 p-4 rounded-lg border border-blue-100" data-id="element-1272">
                <div className="flex justify-between items-center mb-2" data-id="element-1273">
                  <span className="text-sm font-medium text-blue-900" data-id="element-1274">
                    Estimasi Penerima
                  </span>
                  <span className="text-2xl font-bold text-blue-700" data-id="element-1275">514</span>
                </div>
                <p className="text-xs text-blue-600" data-id="element-1276">
                  Campaign akan didistribusikan ke seluruh akun Officer yang
                  terdaftar dalam grup target.
                </p>
              </div>

              <div className="space-y-2 border-t pt-4" data-id="element-1277">
                <h4 className="text-sm font-medium text-gray-900" data-id="element-1278">
                  Tracking & Notifikasi
                </h4>
                <div className="flex items-center gap-2" data-id="element-1279">
                  <input type="checkbox" id="utm" className="rounded text-primary-600" defaultChecked data-id="element-1280" />
                  <label htmlFor="utm" className="text-sm text-gray-700" data-id="element-1281">
                    Generate UTM Link otomatis untuk tracking klik
                  </label>
                </div>
                <div className="flex items-center gap-2" data-id="element-1282">
                  <input type="checkbox" id="notif" className="rounded text-primary-600" defaultChecked data-id="element-1283" />
                  <label htmlFor="notif" className="text-sm text-gray-700" data-id="element-1284">
                    Kirim notifikasi WhatsApp ke Officer
                  </label>
                </div>
              </div>
            </div>}

          {step === 4 && <div className="space-y-4 animate-in fade-in" data-id="element-1285">
              <div className="bg-gray-50 p-4 rounded-lg space-y-3" data-id="element-1286">
                <h3 className="font-bold text-gray-900" data-id="element-1287">Review Campaign</h3>
                <div className="grid grid-cols-2 gap-4 text-sm" data-id="element-1288">
                  <div data-id="element-1289">
                    <span className="text-gray-500 block" data-id="element-1290">Judul</span>
                    <span className="font-medium" data-id="element-1291">Kampanye HPSN 2025</span>
                  </div>
                  <div data-id="element-1292">
                    <span className="text-gray-500 block" data-id="element-1293">Deadline</span>
                    <span className="font-medium" data-id="element-1294">21 Feb 2025</span>
                  </div>
                  <div data-id="element-1295">
                    <span className="text-gray-500 block" data-id="element-1296">Target</span>
                    <span className="font-medium" data-id="element-1297">514 Penerima</span>
                  </div>
                  <div data-id="element-1298">
                    <span className="text-gray-500 block" data-id="element-1299">Platform</span>
                    <span className="font-medium" data-id="element-1300">IG, TikTok, FB</span>
                  </div>
                </div>
              </div>
              <div className="flex items-start gap-2 text-sm text-yellow-700 bg-yellow-50 p-3 rounded-lg border border-yellow-200" data-id="element-1301">
                <AlertCircle className="h-5 w-5 flex-shrink-0" data-id="element-1302" />
                <p data-id="element-1303">
                  Setelah dipublish, campaign akan langsung muncul di aplikasi
                  Officer daerah. Pastikan materi sudah benar.
                </p>
              </div>
            </div>}
        </div>
      </Modal>
    </CommandCenterLayout>;
}